<template>
  <div class="d-flex justify-center mb-4">
    <img src="/images/logo_300.png" width="120" />
  </div>

  <div class="login" style="margin: auto;">
    <LoginForm />
  </div>

  <div class="my-10">
    <SnsLogin />
  </div>

  <div class="mb-4">
    <router-link replace :to="{ name: 'contentViewer', query: { page_uri: `/member/regist/form` } }"
      class="text-decoration-none">
    <div class="pa-4 bg-primary-container text-center">
      <v-icon size="small">mdi-clipboard-account</v-icon> 新規会員登録はこちらから
    </div>
    </router-link>
  </div>

  <div class="mb-3">
    <SpecialPageList />
  </div>

  <GuideButton />
</template>

<script>
import LoginForm from '../components/LoginForm.vue'
import SnsLogin from '../components/SnsLogin.vue'
import GuideButton from '../components/guideButton.vue'
import SpecialPageList from '../components/SpecialPageList.vue'

export default {
  name: 'LoginPage',
  components: {
    LoginForm,
    SnsLogin,
    GuideButton,
    SpecialPageList
  },
  data() {
    return {
    }
  },
  // コンポーネントマウントリスナ
  async mounted() {
  },
  methods: {
  }
}
</script>